<template>

  <div class="col-lg-10 col-lg-offset-1">
    <v-card flat>
      <v-card-title> Add Donation</v-card-title>
      <v-form @submit.prevent="postInventory()">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="First Name"
                v-model="donation.first_name"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Sur Name"
                v-model="donation.last_name"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Email"
                v-model="donation.email"
                :rules="requiredRules"
                required
                type="email"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Phone Number (e.g. 1-347382374)"
                placeholder="code - number e.g. 1-347382374"
                v-model="donation.phone_number"
                :rules="requiredRules"
                required
                type="tel"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-select
                label="Payment Frequency"
                v-model="donation.frequency"
                :items="allFrequency"
                :rules="[v => !!v || 'Item is required']"
                required
                item-text="name"
                item-value="public_id"
                :loading="$loadingTrue"
              ></v-select>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Amount"
                v-model="donation.amount"
                :rules="requiredRules"
                required
                type="number"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Payment Method"
                v-model="donation.payment_method"
                :items="allPaymentMethods"
                :rules="[v => !!v || 'Item is required']"
                required
                item-text="name"
                item-value="public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Donate to"
                v-model="donation.payment_method"
                :items="allCauses"
                :rules="[v => !!v || 'Item is required']"
                required
                item-text="name"
                item-value="public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-select
                label="Anonymity"
                v-model="donation.payment_method"
                :items="allAnonimity"
                :rules="[v => !!v || 'Item is required']"
                required
                item-text="name"
                item-value="public_id"
                :loading="$loadingTrue"
              ></v-select>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-select
                label="Gender"
                v-model="donation.payment_method"
                :items="['Male', 'Female']"
                :rules="[v => !!v || 'Item is required']"
                required
              ></v-select>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Country"
                v-model="donation.country"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="City"
                v-model="donation.city"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="donation.dob"
              >
                <v-text-field
                  slot="activator"
                  label="Date of Birth"
                  v-model="donation.dob"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="donation.dob" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(donation.dob)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" block color="info" type="submit">Submit Donation Request</v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import DonationVuex from '../../../mixins/Computed/DonationVuex'
export default {
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      menu1: false,
      modal1: false,
      donation: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        frequency: '',
        payment_method: '',
        description: '',
        code: '',
        capacity: '',
        public_id: this.$route.params.donation_id
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_countries')
    this.$store.dispatch('get_all_anonymity')
    this.$store.dispatch('get_all_frequency')
    this.$store.dispatch('get_all_payment_methods')
    this.$store.dispatch('get_all_causes')
  },
  methods: {
    postInventory: function () {
      this.$store.dispatch('post_back_donation', this.donation)
    }
  },
  mixins: [DonationVuex]
}
</script>

<style>

</style>
